import { Box, ButtonV2, FormControl } from '@withjoy/joykit';
import { Search } from '@withjoy/joykit/icons';
import React from 'react';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';
import { useIsMobileOrTablet } from '@shared/utils/media/useMediaScreens';

export const SubmitButton = () => {
  const { t } = useTranslation('accommodationsConsole');
  const submitTrans = t('mobileSearch');
  const isMobileOrTablet = useIsMobileOrTablet();

  if (isMobileOrTablet) {
    return (
      <FormControl
        width={'100%'}
        background={'transparent'}
        padding={0}
        marginTop={5}
      >
        <ButtonV2
          type="submit"
          width="100%"
          variant="solid"
          shape="rounded"
          intent="neutral"
        >
          {submitTrans.save()}
        </ButtonV2>
      </FormControl>
    );
  }

  return (
    <FormControl>
      <ButtonV2
        type="submit"
        variant="solid"
        intent={'newPrimary'}
        shape={'rounded'}
        width={pxToRem(48)}
        height={pxToRem(40)}
      >
        <Box
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Search />
        </Box>
      </ButtonV2>
    </FormControl>
  );
};
